import React, { PureComponent } from "react";

import classNames from "classnames";

import Materials from "./editor-materials";

import HyperModal from "react-hyper-modal";
import Carousel from "react-bootstrap/Carousel";
import { withTranslation } from "react-i18next";
import { getPublicUrl } from "../../utils/utils";

class EditorSidebar extends PureComponent {
  constructor(props) {
    super(props);

    const { t } = props;

    this._bottom = React.createRef();
    this.materialInfo = null;
    this.styles = [
      {
        id: "simple_white",
        name: "white",
      },
      {
        id: "simple_black",
        name: "black",
      },
    ];

    this.state = {
      sidebarMenuLinks: [true, false, false, false],
      isModalOpen: false,
      isProposedTextModalOpen: false,
      proposalHangerPrice: 0,
    };

    this._proposedTexts = [
      t("Зорі, під якими\nпочалася наша історія\n❤️"),
      t("День, коли\nпочалася наша пригода\n❤️"),
      t("Казкова мить\n❤️"),
      t("Мої щасливі зорі"),
      t("Найкращий день мого життя\n❤️"),
      t("Точка відліку"),
      t("Початок великої подорожі"),
      t("Ти з’явився в моєму житті\n❤️"),
      t("Ми зустрілись під цими зорями\n❤️"),
      t("Ти народилася, щоб запалити цей світ"),
    ];
    this._selectedProposedTextIndex = 0;
    this._isSmallScreen = true;
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    console.log("Calculating window size");
    let width = window.innerWidth;
    this._isSmallScreen = width < 768 ? true : false;
  };

  scrollToBottom = () => {
    console.log("scrolling");
    try {
      this._bottom.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  onSideBarMenuClick = (e, index) => {
    e.preventDefault();

    var sidebarMenuLinks = [...this.state.sidebarMenuLinks];

    for (var i = 0; i < sidebarMenuLinks.length; i++) {
      if (i === index) {
        sidebarMenuLinks[i] = true;
      } else {
        sidebarMenuLinks[i] = false;
      }
    }
    if (this._isSmallScreen) {
      this.setState(
        { sidebarMenuLinks: sidebarMenuLinks },
        this.scrollToBottom
      );
    } else {
      this.setState({ sidebarMenuLinks: sidebarMenuLinks });
    }
  };

  onMaterialChanged = (info) => {
    this.materialInfo = info;
    this.props.onMaterialChanged(info);
  };

  onMakeOrderClick = (e) => {
    e.preventDefault();
    if (this.materialInfo && this.materialInfo.proposalHangerPrice > 0) {
      this.setState({
        isModalOpen: true,
        proposalHangerPrice: this.materialInfo.proposalHangerPrice,
      });
    } else {
      this.props.onMakeOrderClick();
    }
  };

  onAddFrameClick = (e) => {
    e.preventDefault();
    var materialAlterInfo = {
      selectedHangerId: this.materialInfo.proposalHangerId,
      selectedHangerName: this.materialInfo.proposalHangerName,
      price: this.materialInfo.price + this.materialInfo.proposalHangerPrice,
    };
    this.props.onMakeOrderClick(materialAlterInfo);
  };

  onContinueWithoutFrameClick = (e) => {
    e.preventDefault();
    this.props.onMakeOrderClick();
  };

  renderSidebarMenu({ t }) {
    var createItem = (name, icon) => {
      return { name: name, icon: icon };
    };

    var items = [
      createItem(t("Стиль"), "fa-paint-brush"),
      createItem(t("Матеріал"), "fa-map"),
      createItem(t("Написи"), "fa-pencil"),
      createItem(t("Аудіо"), "fa-microphone"),
    ];

    return items.map((item, index, array) => {
      var itemClass = classNames(
        "h-100 g-color-white-opacity-0_6 g-color-primary--hover g-text-underline--none--hover g-font-weight-400",
        {
          active: this.state.sidebarMenuLinks[index],
        }
      );
      return (
        <li className="w-100" key={"sidebar_" + index}>
          <a
            className={itemClass}
            role="button"
            href="#"
            onClick={(e) => this.onSideBarMenuClick(e, index)}
          >
            <span className={"fa " + item.icon}></span>
            <br />
            {item.name}
          </a>
        </li>
      );
    });
  }

  renderStyles = () => {
    const { t } = this.props;

    return (
      <div className="d-flex align-items-center g-overflow-x-auto d-md-block">
        {this.styles.map((style, index) => {
          return (
            <label className="g-mr-10" key={"style_" + index}>
              <div
                className={
                  "position-relative g-pa-3 custom-selection custom-selection-80-60 " +
                  (this.props.selectedStyleId === style.id
                    ? "custom-selection-active"
                    : "")
                }
              >
                <div className="position-relative h-100 w-100">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/img/audio/styles/" +
                      style.id +
                      ".png"
                    }
                    className="d-block g-absolute-centered w-100 h-100"
                  />
                </div>
                <input
                  className="g-hidden-xs-up g-pos-abs g-top-10 g-left-10"
                  type="radio"
                  name="posterStyles"
                  checked={this.props.selectedStyleId === style.id}
                  onChange={(e) => this.props.onStyleChanged(e, style.id)}
                />
                <i className="fa fa-check g-pos-abs g-top-0 g-right-0 g-color-primary g-bg-white  g-font-size-16 g-pa-3 g-ma-1"></i>
              </div>
              <p className="text-center" style={{ fontSize: "12px" }}>
                {style.name}
              </p>
            </label>
          );
        })}
      </div>
    );
  };

  // renderStyles = () => {
  //   const { t } = this.props;

  //   return (<div className="d-flex align-items-center justify-content-between g-overflow-x-auto">
  //     <div className="d-flex d-md-block">
  //       {this.styles.map((style, index) => {
  //         return (
  //           <label className="u-check g-mr-10" key={"style_" + index}>
  //             <div
  //               className="position-relative"
  //               style={{
  //                 width: "60px",
  //                 height: "80px",
  //                 margin: "auto",
  //               }}
  //             >
  //               <input
  //                 className="g-hidden-xs-up g-pos-abs g-top-10 g-left-10"
  //                 type="radio"
  //                 name="posterStyles"
  //                 checked={this.props.selectedStyleId === style.id}
  //                 onChange={(e) =>
  //                   this.props.onStyleChanged(e, style.id)
  //                 }
  //               />
  //               <div className="u-check-icon-checkbox-v3 w-100 h-100">
  //                 <img
  //                   src={
  //                     process.env.PUBLIC_URL +
  //                     "/assets/img/styles/" +
  //                     style.id +
  //                     ".png"
  //                   }
  //                   className="d-block g-absolute-centered w-100 h-100"
  //                 />
  //                 <div
  //                   className="g-absolute-centered  w-100 h-100 g-bg-black g-show-check"
  //                   style={{ opacity: 0.4 }}
  //                 ></div>
  //                 <i className="fa fa-check g-absolute-centered g-color-white g-show-check g-font-size-16"></i>
  //               </div>
  //             </div>
  //             <p className="text-center" style={{ fontSize: "12px" }}>
  //               {style.name}
  //             </p>
  //           </label>
  //         );
  //       })}
  //     </div>
  //   </div>
  //   )
  // };

  // <div className={"form-group g-mb-10 "} key={"feature_" + index}>
  //   <label className="u-check g-pl-25">
  //     <input
  //       className="g-hidden-xs-up g-pos-abs g-top-0 g-left-0"
  //       type="checkbox"
  //       checked={feature.isEnabled}
  //       onChange={(e) => this.props.onFeatureChanged(e, feature.id)}
  //     />
  //     <div className="u-check-icon-checkbox-v4 g-absolute-centered--y g-left-0">
  //       <i className="fa" data-check-icon=""></i>
  //     </div>
  //     {t(feature.name)}
  //   </label>
  // </div>

  onModalClose = (e) => {
    this.setState({
      isModalOpen: false,
    });
  };

  proposedTextModalOpen = (e) => {
    e.preventDefault();
    this.setState({
      isProposedTextModalOpen: true,
    });
  };

  onProposedTextModalClose = (e) => {
    this.setState({
      isProposedTextModalOpen: false,
    });
  };

  onProposedTextSwitched = (selectedIndex, e) => {
    this._selectedProposedTextIndex = selectedIndex;
  };

  onProposedTextSelected = (e) => {
    if (this._selectedProposedTextIndex >= this._proposedTexts.length) {
      this._selectedProposedTextIndex = this._proposedTexts.length - 1;
    }
    var text = this._proposedTexts[this._selectedProposedTextIndex];

    this.onProposedTextModalClose();
    this.props.onText1Selected(text);
  };

  render() {
    console.log("rendering editor-sidebar");
    const { t, i18n } = this.props;

    return (
      <React.Fragment>
        <div className="sidebar-menu g-color-white-opacity-0_6 g-color-primary--hover g-bg-main-light-v1">
          <ul className="list-unstyled d-flex align-items-stretch h-100 g-ma-0 flex-row flex-md-column ">
            <li className="logo d-none d-md-block">
              <a
                href="/audio"
                className="h-100 g-color-white-opacity-0_6 g-color-primary--hover g-text-underline--none--hover g-font-weight-400"
                role="button"
              >
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/img/logo_transparent.png"
                  }
                  className="img-fluid"
                />
              </a>
            </li>
            {this.renderSidebarMenu(this.props)}
          </ul>
        </div>
        <div
          className="sidebar-content non-clickable bd-highlight"
          ref={this._bottom}
        >
          <div className="d-flex flex-column w-100 h-100 u-shadow-v15">
            <div
              id="accordion"
              className="w-100 g-bg-white g-px-15 g-px-20--md g-pt-15 g-pt-20--md g-pb-5 h-100 clickable"
            >
              <div
                className={
                  "collapse " + (this.state.sidebarMenuLinks[0] ? "show" : "")
                }
              >
                <h3 className="h5"> Стиль</h3>
                {this.renderStyles()}
                {/* 
                <div className="d-flex align-items-center justify-content-between g-overflow-x-auto">
                  <div className="d-flex d-md-block g-pt-12">
                    {this.styles.map((style, index) => {
                      return (
                        <label
                          className="u-check g-mr-10 g-mr-15--md mb-0"
                          key={"style_" + index}
                        >
                          <div className="position-relative g-width-50 g-height-50">
                            <input
                              className="g-hidden-xs-up g-pos-abs g-top-10 g-left-10"
                              type="radio"
                              name="posterStyles"
                              checked={this.props.selectedStyleId === style.id}
                              onChange={(e) =>
                                this.props.onStyleChanged(e, style.id)
                              }
                            />
                            <div className="u-check-icon-checkbox-v3 w-100 h-100">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/img/styles/" +
                                  style.id +
                                  ".png"
                                }
                                className="d-block g-absolute-centered rounded-circle w-100 h-100"
                              />
                              <div
                                className="g-absolute-centered rounded-circle w-100 h-100 g-bg-black g-show-check"
                                style={{ opacity: 0.4 }}
                              ></div>
                              <i className="fa fa-check g-absolute-centered g-color-white g-show-check g-font-size-16"></i>
                            </div>
                          </div>
                          <p className="text-center">{style.id}</p>
                        </label>
                      );
                    })}
                  </div>
                </div> */}

                <button
                  className="btn u-btn-primary g-mt-20 rounded-0 g-brd-none float-right step d-none d-md-block"
                  type="button"
                  onClick={(e) => this.onSideBarMenuClick(e, 1)}
                >
                  {t("Крок 2: Матеріал")} <i className="fa fa-angle-right"></i>
                </button>
              </div>
              <div
                className={
                  "collapse " + (this.state.sidebarMenuLinks[1] ? "show" : "")
                }
              >
                <Materials
                  initialSelectedMaterialId={
                    this.props.initialSelectedMaterialId
                  }
                  initialSelectedSizeId={this.props.initialSelectedSizeId}
                  initialSelectedHangerId={this.props.initialSelectedHangerId}
                  onChanged={this.onMaterialChanged}
                ></Materials>

                <button
                  className="btn u-btn-primary g-mt-20 rounded-0 g-brd-none float-right step d-none d-md-block"
                  type="button"
                  onClick={(e) => this.onSideBarMenuClick(e, 2)}
                >
                  {t("Крок 3: Написи")} <i className="fa fa-angle-right"></i>
                </button>
              </div>
              <div
                className={
                  "collapse " + (this.state.sidebarMenuLinks[2] ? "show" : "")
                }
              >
                <h3 className="h5">{t("Написи")}</h3>

                <div className="form-group g-mb-20">
                  <div className="d-flex flex-row justify-content-between align-items-start">
                    <label className="g-mb-10">{t("Текст")}</label>
                    {/* <button
                      className="btn btn-xs u-btn-outline-primary"
                      onClick={this.proposedTextModalOpen}
                    >
                      {t("Інші варіанти")}
                    </button> */}
                  </div>

                  <textarea
                    className="form-control form-control-md g-resize-none rounded-0"
                    rows="3"
                    value={this.props.text1}
                    onChange={this.props.onText1Changed}
                  ></textarea>
                </div>
                <div className="form-group g-mb-20">
                  <label className="g-mb-10">{t("Підпис")}</label>
                  <textarea
                    className="form-control form-control-md g-resize-none rounded-0"
                    rows="3"
                    value={this.props.text2}
                    onChange={this.props.onText2Changed}
                  ></textarea>
                </div>
                <button
                  className="btn u-btn-primary g-mt-20 rounded-0 g-brd-none float-right step d-none d-md-block"
                  type="button"
                  onClick={(e) => this.onSideBarMenuClick(e, 3)}
                >
                  {t("Крок 4: Аудіо")} <i className="fa fa-angle-right"></i>
                </button>
              </div>
              <div
                className={
                  "collapse " + (this.state.sidebarMenuLinks[3] ? "show" : "")
                }
              >
                {/* <h3 className="h5"> Аудіо</h3> */}
                <div
                  className="alert g-bg-gray-light-v5  alert-dismissible fade show"
                  role="alert"
                >
                  <h4 className="h5">
                    <i className="fa fa-info-circle"></i>
                    &nbsp;Запис аудіо
                  </h4>
                  <p>
                    Ви зможете відправити запис вашого голосу пізніше.
                    Наприклад, у вигляді голосового повідомлення у Viber чи
                    Telegram. Посилання з'явиться після оформлення замовлення.
                  </p>
                </div>
                <button
                  className="btn u-btn-primary g-mt-20 rounded-0 g-brd-none float-right step d-none d-md-block"
                  type="button"
                  onClick={this.onMakeOrderClick}
                >
                  {t("Крок 5: Купити")} <i className="fa fa-angle-right"></i>
                </button>
              </div>
            </div>

            <div className="w-100 sidebar-content-buy ">
              <div className="sidebar-menu g-color-white g-bg-primary d-block d-md-none ">
                <ul className="list-unstyled d-flex align-items-stretch h-100 g-ma-0 flex-row flex-md-column ">
                  <li className="w-100">
                    <a
                      className="h-100 g-color-white  g-text-underline--none--hover g-font-weight-400"
                      role="button"
                      href="#"
                      onClick={this.onMakeOrderClick}
                    >
                      <span className="fa fa-shopping-cart"></span>
                      <br />
                      <span> {t("Купити")}</span>{" "}
                      <span>
                        {" "}
                        {this.props.price} {t("грн")}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="d-none d-md-block">
                <button
                  className="btn btn-block u-btn-primary btn-xl g-mt-0 rounded-0 g-brd-none"
                  type="button"
                  onClick={this.onMakeOrderClick}
                >
                  <span className="float-left">
                    <i className="fa fa-shopping-cart"></i> {this.props.price}{" "}
                    {t("грн")}
                  </span>
                  <span className="float-right">
                    {t("Купити")} <i className="fa fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <HyperModal
          isOpen={this.state.isModalOpen}
          requestClose={this.onModalClose}
          classes={{
            contentClassName: "custom-modal-content",
            closeIconClassName: "custom-modal-icon",
            wrapperClassName: "custom-modal-wrapper",
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title">{t("Чудовий вибір!")}</h5>
          </div>
          <div className="modal-body">
            <h5>
              {t("Плакати у рамках виглядають ще краще. Бажаєте додати рамку?")}
            </h5>
            <div className="row g-mt-10 no-gutters">
              <div className="col-auto">
                <img
                  className="img-fluid"
                  src={process.env.PUBLIC_URL + "/assets/img/frame2_sm.png"}
                  alt=""
                  style={{ maxWidth: 80 }}
                />
              </div>
              <div className="col g-pl-10">
                <h6>{t("Рамка")}</h6>
                <p className="g-font-size-default">
                  {t(
                    "Тонка пластикова рамка чорного кольору зі зручним підвісом. Такі рамки добре підходять до будь-якого стилю інтер’єру."
                  )}
                </p>
              </div>
              <div className="col-auto g-pl-10 text-center">
                <button
                  className="btn u-btn-primary rounded-0 g-brd-none"
                  type="button"
                  onClick={this.onAddFrameClick}
                >
                  {t("Додати")}
                </button>
                <br />
                <small className="g-color-primary g-font-size-14 text-nowrap">
                  +{this.state.proposalHangerPrice} {t("грн")}
                </small>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-block u-btn-primary btn-xl g-mt-20 rounded-0 g-brd-none"
              type="button"
              onClick={this.onContinueWithoutFrameClick}
            >
              {t("Продовжити без рамки")}
            </button>
          </div>
        </HyperModal>
        <HyperModal
          isOpen={this.state.isProposedTextModalOpen}
          requestClose={this.onProposedTextModalClose}
          classes={{
            contentClassName: "custom-modal-content",
            closeIconClassName: "custom-modal-icon",
            wrapperClassName: "custom-modal-wrapper",
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title">{t("Оберіть напис")}</h5>
          </div>
          <div className="modal-body custom-carousel">
            <Carousel
              onSelect={this.onProposedTextSwitched}
              interval={null}
              slide={false}
            >
              {this._proposedTexts.map((text, index) => {
                return (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100"
                      src={process.env.PUBLIC_URL + "/assets/img/white.png"}
                    />
                    <Carousel.Caption bsPrefix="custom-carousel-caption">
                      <div>
                        <p className="text-sample h6 h5--md g-color-black">
                          {text}
                        </p>
                      </div>
                    </Carousel.Caption>
                  </Carousel.Item>
                );
              })}
            </Carousel>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-block u-btn-primary btn rounded-0 g-brd-none"
              type="button"
              onClick={this.onProposedTextSelected}
            >
              {t("Обрати цей варіант")}
            </button>
          </div>
        </HyperModal>
      </React.Fragment>
    );
  }
}
export default withTranslation()(EditorSidebar);
